"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var host = document.location.host;

function getCommunityContentEmbedUrl(contentId, autoPlay) {
  return "//" + host + "/embed/video/" + contentId + "?autoPlay=" + autoPlay + "&isTimeline=true";
}

function getHighlightEmbedUrl(feedUserType, ownerId, contentId, autoPlay) {
  return "//" + host + "/embed/video/" + feedUserType + "/" + ownerId + "/" + contentId + "?autoPlay=" + autoPlay + "&isTimeline=true";
}

function getAthleteHighlightEmbedUrl(userId, contentId, autoPlay) {
  return "//" + host + "/embed/video/2/" + userId + "/" + contentId + "?autoPlay=" + autoPlay + "&isTimeline=true";
}

function getTeamHighlightEmbedUrl(teamId, contentId, autoPlay) {
  return "//" + host + "/embed/video/3/" + teamId + "/" + contentId + "?autoPlay=" + autoPlay + "&isTimeline=true";
}

function getFeedUserProfileUrl(type, relatedId) {
  return "http://" + host + "/profiles/feed-user/" + type + "-" + relatedId;
}

function getPublicHighlightUrl(ownerType, ownerId, contentId, shortenedUrlId) {
  if (shortenedUrlId) {
    return "http://" + host + "/v/" + shortenedUrlId;
  }

  return "http://" + host + "/video/" + ownerType + "/" + ownerId + "/" + contentId;
}

exports.default = {
  getCommunityContentEmbedUrl: getCommunityContentEmbedUrl,
  getHighlightEmbedUrl: getHighlightEmbedUrl,
  getAthleteHighlightEmbedUrl: getAthleteHighlightEmbedUrl,
  getTeamHighlightEmbedUrl: getTeamHighlightEmbedUrl,
  getFeedUserProfileUrl: getFeedUserProfileUrl,
  getPublicHighlightUrl: getPublicHighlightUrl
};